import { createSlice } from "@reduxjs/toolkit";
import {TEAM} from "../../db/data.js";

const initialState = { team: []};

const teamSlice = createSlice({
    
    name: "team",
    initialState,
    reducers : {
        loadTeam : (state,action) => {
            state.team = TEAM ;
        },
        addTeam : (state,action) => {
            state.team.push(action.payload);
        }
    },
    // extraReducers : (builder) => {
    //     builder.addCase('actionCreator',(state,action)=> {

    //     })
    // }
});

//export generated slice reducer and action creators
export default teamSlice.reducer;
export const { loadTeam, addTeam } = teamSlice.actions;

//export state slice team
export const selectTeam = (state) => state.team;